export default __webpack_public_path__ + "static/media/GyroAccImg.0e35a4b8.jpg";